import React from "react"
import { useInView } from "react-intersection-observer"
import { GridLines, Headline, Eyebrow } from "@shared"
import { css } from "@jsUtils"
import { PageSection } from "../PageSection"

import PillarGraphic from "./PillarGraphic"

// eslint-disable-next-line no-unused-vars
import Styles from "./companyPillars.module.scss"

const MOBILE_BREAKPOINT = 1240

const Pillar = props => {
  const { color, headline, index, children, setFormat, mobileLayout } = props
  const [ready, setReady] = React.useState(false)
  const [ref, inView] = useInView({
    threshold: 0.2
  })
  const [refInner, innerInView] = useInView({
    threshold: 0.45
  })

  React.useEffect(() => {
    if (inView && !ready) {
      setReady(true)
    }
    if (innerInView) {
      setFormat(index)
    }
  }, [inView, innerInView])
  return (
    <div className={css(Styles.pillarWrapper, ready && Styles.pillarReady)} ref={ref}>
      {mobileLayout ? (
        <PillarGraphic className={Styles.graphicMobile} format={ready ? index : -1} />
      ) : (
        ""
      )}
      <div className={Styles.pillar} ref={refInner}>
        <Headline className={Styles.pillarIndex} size={3} color={color}>
          {`0${index + 1}`}
        </Headline>
        <Headline className={Styles.pillarHeadline} size={3}>
          {headline}
        </Headline>
        <p className={Styles.pillarBody}>{children}</p>
      </div>
    </div>
  )
}

/**
 * Feature Scroll - Sticky animation next to scrolling text
 * @param {object} props - React props
 */
// eslint-disable-next-line react/no-multi-comp
const CompanyPillars = props => {
  const { theme, color, pillars } = props

  const [ref, inView] = useInView({
    threshold: 0.15
  })

  const [format, setFormat] = React.useState(-1)
  const [mobileLayout, setMobileLayout] = React.useState(false)

  const onResize = () => {
    if (window.innerWidth < MOBILE_BREAKPOINT && !mobileLayout) {
      setMobileLayout(true)
    } else if (window.innerWidth >= MOBILE_BREAKPOINT && mobileLayout) {
      setMobileLayout(false)
    }
  }

  React.useEffect(() => {
    onResize()
    window.addEventListener("resize", onResize)
    return () => {
      window.removeEventListener("resize", onResize)
    }
  })

  const pillarSections = pillars.map((pillar, index) => {
    return (
      <Pillar
        key={`pillar-${pillar.id}`}
        color={color}
        index={index}
        headline={pillar.headline}
        setFormat={setFormat}
        mobileLayout={mobileLayout}
      >
        {pillar.description}
      </Pillar>
    )
  })
  return (
    <PageSection className={Styles.section} theme={theme}>
      <GridLines theme={theme} />
      <div className={Styles.wrapper}>
        {!mobileLayout ? (
          <div className={css(Styles.graphicWrapper, `companyPillarsIEOverride`)}>
            <PillarGraphic className={Styles.graphic} format={inView ? format : -1} />
          </div>
        ) : (
          ""
        )}
        <div className={Styles.content}>
          <div className={Styles.header}>
            <Eyebrow color={color}>What Drives Us</Eyebrow>
          </div>
          <div ref={ref}>{pillarSections}</div>
        </div>
      </div>
    </PageSection>
  )
}

export default CompanyPillars
